// JS
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import {
  ppHeadingOverridesClose,
  getInternationalPriceNuqlium
} from '../shared/utils';

// COMPONENT
const PaymentPopup = ({
  data,
  showHidePaymentPopup,
  setShowHidePaymentPopup,
  klarnaProdPrice,
  disableOverrides = true
}) => {
  const closePaymentPopupCleanUp = () => {
    setShowHidePaymentPopup(false);
    window.scrollLock();
    disableOverrides && ppHeadingOverridesClose();
  };

  // DEVICES
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <>
      {showHidePaymentPopup && data && (
        <>
          <div
            id="payment-popup-overlay"
            className="animate-fadeIn"
            onClick={(e) => {
              if (e.currentTarget === e.target && !isMobile) {
                setTimeout(() => {
                  closePaymentPopupCleanUp();
                }, '400');
                document.getElementById('payment-popup-overlay').className =
                  'animate-fadeOut';
                document.getElementById('payment-popup-content').className =
                  isMobile ? 'fade-out-down' : 'fade-out-right';
              }
            }}
          >
            <div
              id="payment-popup-content"
              className={isMobile ? 'fade-in-up' : 'fade-in-left'}
            >
              <div
                id="payment-popup-details-close"
                onClick={() => {
                  setTimeout(() => {
                    closePaymentPopupCleanUp();
                  }, '400');
                  document.getElementById('payment-popup-overlay').className =
                    'animate-fadeOut';
                  document.getElementById('payment-popup-content').className =
                    isMobile ? 'fade-out-down' : 'fade-out-right';
                }}
              ></div>
              <div className="payment-popup-details klarna">
                <div className="buy-now-pay-later-side-panel">
                  <div className="bnpl-top">
                    <div className="bnpl-logo-wrapper">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 69 34.5"
                      >
                        <rect
                          width={69}
                          height={34.5}
                          rx={4.182}
                          ry={4.182}
                          fill="#f5f5f5"
                        />
                        <path
                          d="M53.739 19.461a1.167 1.167 0 1 0-.007 2.333 1.167 1.167 0 0 0 .007-2.333Zm-3.822-.905a1.68 1.68 0 1 0-1.753 1.602l.08.002c.904.018 1.652-.7 1.673-1.604Zm.006-3.12h1.85v6.238h-1.85v-.398a3.23 3.23 0 0 1-1.835.571 3.291 3.291 0 0 1 0-6.581 3.217 3.217 0 0 1 1.835.571v-.4Zm-14.81.812v-.811h-1.896v6.237h1.9v-2.913c0-.983 1.055-1.511 1.787-1.511h.022v-1.814a2.3 2.3 0 0 0-1.812.811Zm-4.719 2.307a1.68 1.68 0 1 0-1.753 1.602l.08.002c.904.018 1.652-.7 1.673-1.604Zm.006-3.12h1.851v6.238H30.4v-.398a3.23 3.23 0 0 1-1.835.571 3.291 3.291 0 0 1 0-6.581 3.217 3.217 0 0 1 1.835.571v-.4Zm11.138-.167a2.243 2.243 0 0 0-1.907.87v-.702h-1.842v6.237h1.865v-3.279a1.31 1.31 0 0 1 1.389-1.414c.812 0 1.282.49 1.282 1.4v3.29h1.847v-3.964a2.455 2.455 0 0 0-2.634-2.439Zm-18.93 6.404h1.937v-9.017h-1.937v9.018Zm-8.51 0h2.051v-9.017h-2.05v9.018Zm7.175-9.018a7.206 7.206 0 0 1-2.098 5.123l2.835 3.901h-2.534l-3.08-4.241.796-.601a5.195 5.195 0 0 0 2.072-4.182h2.009Z"
                          fill="#0a0b09"
                        />
                      </svg>
                    </div>

                    {data.product.option.priceasnumber >= 1000 ? (
                      <span className="bnpl-content-wrapper">
                        Pay in 30 days. No fees.
                      </span>
                    ) : (
                      <span className="bnpl-content-wrapper">
                        Make 3 payments of{' '}
                        {getInternationalPriceNuqlium() === 'retail_eur' ? (
                          <span className="bnpl-price">
                            &euro;{klarnaProdPrice}
                          </span>
                        ) : (
                          <span className="bnpl-price">
                            &pound;{klarnaProdPrice}
                          </span>
                        )}
                        .
                      </span>
                    )}
                  </div>
                  <div className="bnpl-steps">
                    <div className="bnpl-step">
                      <h3>Step 1</h3>
                      <p>
                        Add products to your basket and select ‘Klarna’ in the
                        checkout.
                      </p>
                    </div>
                    <div className="bnpl-step">
                      <h3>Step 2</h3>
                      <p>
                        Enter a few details and you'll know instantly if you're
                        approved.
                      </p>
                    </div>
                    <div className="bnpl-step">
                      <h3>Step 3</h3>
                      <p>
                        Klarna will send you an email confirmation and reminders
                        when it's time to pay and you can manage your orders and
                        payments in the Klarna app.
                      </p>
                    </div>
                  </div>
                  <div className="bnpl-boxes">
                    <div className="bnpl-box">
                      <h3>Pay in 30 days</h3>
                      <p>
                        Make your purchase today so you can try before you buy.
                        Only pay for what you keep. Pay up to 30 days later. No
                        interest. No impact to your credit score.
                      </p>
                    </div>

                    {data.product.option.priceasnumber <= 999 && (
                      <div className="bnpl-box">
                        <h3>Pay in 3 interest-free instalments</h3>
                        <p>
                          Spread the cost of your purchase into 3 interest-free
                          instalments. The first payment is made at point of
                          purchase, with remaining instalments scheduled
                          automatically every 30 days. No interest. Select the
                          Klarna option and enter your debit or credit card
                          information. To check your eligibility, Klarna will
                          perform a soft search with a credit reference agency.
                          This will not affect your credit score.
                        </p>
                      </div>
                    )}

                    <div className="bnpl-box small">
                      <p>
                        Find out more{' '}
                        <a
                          href="https://www.sevenstore.com/help-hub/#/klarna"
                          target="_blank"
                          rel="noreferrer"
                        >
                          here
                        </a>
                      </p>
                    </div>
                  </div>
                  <p className="bnpl-tcs">
                    Klarna's Pay in 3 / Pay in 30 days are unregulated credit
                    agreements. Borrowing more than you can afford or paying
                    late may negatively impact your financial status and ability
                    to obtain credit. 18+, UK residents only. Subject to status.
                    Ts&Cs and late fees apply.
                  </p>
                  <p className="bnpl-tcs">
                    View Klarna{' '}
                    <a
                      href="https://www.klarna.com/uk/terms-and-conditions/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Terms and Conditions
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PaymentPopup;
